import React from 'react';
import styled from 'styled-components';
import { formatNumberWithCommas } from 'Utils/UtilityFunctions';
import {
  primaryColor, primaryFont, wMBold, wMedium,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  width: 100%;
  .left-side {
    display: flex;
    align-items: center;
    .new-tag{
      border: 2px solid ${primaryColor};
      border-radius: 3px;
      font-size: 10px;
      color: ${primaryColor};
      font-weight: ${wMedium};
      font-family: ${primaryFont};
      margin-left: 10px;
      padding: 0px 3px;
    }
  }
`;
const ColorBox = styled.span<{ color: string }>`
 background-color: ${(props) => props.color};
 height: 16px;
 width: 16px;
 float: left;
`;

const Title = styled.span<{ fontWeight: string }>`
  color: #3F4B50;
  font-size: 14px;
  letter-spacing: -0.35px;
  font-family: ${primaryFont};
  font-weight: ${(props) => props.fontWeight};
  margin-left: 10px;
`;

const Stats = styled.span`
  color: #06061A;
  font-size: 16px;
  font-weight: ${wMedium};
  font-family: ${primaryFont};
  span{
  font-weight: ${wMBold};
  margin-right: 4px;
  }
`;

type Props = {
  color?: string,
  title?: string,
  stats?: number,
  pts?: number,
  NoPts?: boolean,
  fontWeight?: string,
  isNew?: boolean,
} | typeof defaultProps;

const defaultProps = {
  color: 'red',
  title: 'Company View',
  stats: 0,
  pts: 0,
  NoPts: false,
  fontWeight: '',
  isNew: false,
};

const ScoreStatsTip = function ScoreStatsTip(props: Props) {
  const {
    color, title, stats = 0, pts = 0, NoPts, fontWeight, isNew,
  } = props;

  const formattedPointsCount = formatNumberWithCommas(pts);
  const formattedStatesCount = formatNumberWithCommas(stats);

  return (
    <Wrapper>
      <div className="left-side">
        <ColorBox color={color || ''} />
        <Title fontWeight={fontWeight || ''}>{title}</Title>
        {isNew ? <span className="new-tag">New</span> : null}
      </div>
      <div className="right-side">
        <Stats>
          <span>{formattedStatesCount}</span>
          {NoPts ? null : (
            <span>
              (
              {formattedPointsCount}
              pts)
            </span>
          )}
        </Stats>
      </div>
    </Wrapper>
  );
};

ScoreStatsTip.defaultProps = defaultProps;
export default ScoreStatsTip;
